import type { ReactNode } from 'react';

export const symbol_sports_handball: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="m348-303-60 97q-6 10-17.5 12.5T248-197q-11-6-13.5-17.5T239-237l213-346q-42-37-63-80.5T368-755q0-31 4.5-57t16.5-55q5-11 16.5-15.5T428-881q11 6 15 18t-1 24q-8 20-11 39t-3 39q0 48 23 87t77 71l97 57q57 33 84.5 81.5T737-353q0 32-8 64t-22 63q-5 11-17 15t-23-2q-11-6-14.5-18t1.5-24q11-24 17-48t6-50q0-38-13-69.5T625-471L367-31q-6 11-17.5 13.5T327-21q-11-6-13.5-17.5T317-61l113-193-82-49Zm289-311q-30 0-51.5-21.5T564-687q0-30 21.5-51.5T637-760q30 0 51.5 21.5T710-687q0 30-21.5 51.5T637-614Zm-94-186q-26 0-43-17t-17-43q0-26 17-43t43-17q26 0 43 17t17 43q0 26-17 43t-43 17Z"
		/>
	</svg>
);
